<template>
  <div
    :class="`
      workpacke-info-body
      ${color}
      ${color.includes('lighten') || color.includes('darken')? '':'lighten-1'}
      font-weight-light
      `"
    :style="`
      ${info_box?'height: calc(60vmin - 36px);':''}
      ${info_box?'max-height: 364px;':''}
      ${wallet?'border-radius: 0px 0px 10px 10px; padding: 0px 3px 0px 3px;':''}
      color: ${textcolor};
    `"
    >
    <slot name="dialogs"/>
    <slot
      name="body-content"
      :workpackage="workpackage"
      :work_card="work_card"
      :quality_card="quality_card"
      :defect_card="defect_card"
      :handover_card="handover_card"
      :logistic_card="logistic_card"
      :design_card="design_card"
      />
    <div class="workpackage-info-buttons">
      <slot name="buttons" :workpackage="workpackage"/>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['color', 'workpackage', 'work_card', 'quality_card', 'defect_card', 'handover_card', 'logistic_card', 'design_card', 'info_box', 'wallet', 'textcolor']
  }
</script>
<style>
  .workpacke-info-body {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 0px 0px 3px 3px;
    transition: background-color 200ms;
    padding: 3px;
    overflow-y: auto;
    /* overflow-y: hidden; */
    overflow-x: hidden;
  }
  .workpackage-info-buttons {
    position: sticky;
    position: -webkit-sticky;
    bottom: 3px;
    display: flex;
    justify-content: space-around;
    z-index: 4;
    margin-top: 10px;
  }
</style>
